import CumTime from "components/icons/CumTime";
import RateCum from "components/icons/RateCum";
import RateDate from "components/icons/RateDate";
import RateTime from "components/icons/RateTime";
import TotalRateCum from "components/icons/TotalRateCum";

// Index-aligned with ChartTypeMultiProduct[0].items — Tabs.tsx looks icons up by position.
export const chartTypeIconsGroupedMultiProduct = [
  <RateCum key="rate-cum" />,
  <RateTime key="rate-time" />,
  <CumTime key="cum-time" />,
  <RateDate key="rate-date" />,
  <TotalRateCum key="total-rate-cum" />
];
